import Landing from './Landing.vue'
import ContactUs from './ContactUs.vue'
import PublicView from './PublicView.vue'
import SignUp from './SignUp.vue'
import Terms from './Terms.vue'
import PrivacyPolicy from './Privacy.vue'
export { Landing, ContactUs, PublicView, SignUp, Terms, PrivacyPolicy }
